<!--
 * @Author: your name
 * @Date: 2021-11-10 15:16:03
 * @LastEditTime: 2021-11-11 09:23:24
 * @LastEditors: Please set LastEditors
 * @Description: 敬请期待页面
 * @FilePath: \xingmahui_front\src\views\common\index.vue
-->
<template>
  <div class="wrap">
    <img class="bg" src="./../../assets/images/common/followBg1.png" alt="">
    <img class="text" src="./../../assets/images/common/text.png" alt="">
  </div>
</template>

<style lang="less" scoped>
.wrap{
  overflow: hidden;
  width: 100%;
  height: 100%;
  .bg{
    width: 100%;
    height: 100vh;
  }
  .text{
    width: 250px;
    height: 190px;
    position: absolute;
    left: 64px;
    top: 143px;
  }
}
</style>

<script>
export default {
  name: "follow",
  components: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {
      
  },
  created() {},
  methods: {}
};
</script>